import type { CSSProperties } from 'react';

/** Keeps formatted currency (e.g. `$5,000.00`) on one line in HTML preview tables. */
export const MONEY_CELL_STYLE: CSSProperties = {
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
  overflowWrap: 'normal',
  wordBreak: 'normal'
};

/** Min width so `$XX,XXX.XX` fits under fixed table layout without mid-number wrap. */
export const MONEY_COLUMN_MIN_WIDTH = '6.5em';
